import InvoiceManage from '@/pages/invoiceManage/invoiceManage'
import InvoiceDetailDetail from '@/pages/orderManage/agOrderList/OrderDetail'

export default [
  {
    path: '/qdInvoiceManage',
    name: 'QdInvoiceManage',
    component: InvoiceManage,
    meta: { name: '开票管理' }
  },
  {
    path: '/qdInvoiceManage/orderDetail/:orderId',
    name: 'QdInvoiceDetailDetail',
    component: InvoiceDetailDetail,
    props: true,
    meta: { name: ['开票管理', '订单详情'] }
  }
]



// WEBPACK FOOTER //
// ./src/router/invoiceManage/invoiceManage.js